import React, { memo } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

const Span = styled.span`
  color: #ac936a;
  font-size: 23px;
  margin: 0 auto;
`;

const TotalPayout = memo(({ cards }) => {
  const payout = cards.reduce((acc, card) => {
    return acc + Number(card.cashValue);
  }, 0.0);
  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      currencySign: "accounting",
      style: "currency",
      currency: "USD",
    }).format(amount);

  return <Span>Total Payout: {formatCurrency(payout)}</Span>;
});

TotalPayout.propTypes = { cards: PropTypes.array.isRequired };

export { TotalPayout };
